import api from './api';

const agentService = {
  getProfile: () => api.get('/agent/profile'),
  getAssignedEvents: () => api.get('/agent/assigned-events'),
  scanTicket: (data) => api.post('/agent/scan-ticket', data),
  getTransactions: (params) => api.get('/agent/transactions', { params }),
};

export default agentService;

